<app-vehicle-group
  (onHideEvent)="onHideDisplayGroup($event)"
  [display]="displayGroup"
  (isConfirmedEvent)="onConfirmRender($event)"
></app-vehicle-group>
<app-vehicles *ngIf="listTable == 0"></app-vehicles>
<!-- <app-tree-table
  (eventDisplayGroup)="eventDisplayGroup($event)"
  *ngIf="listTable == 1"
></app-tree-table> -->
<app-content-panel-vehicles
  (eventDisplayGroup)="eventDisplayGroup($event)"
></app-content-panel-vehicles>
